import { render } from "./AppMenu.vue?vue&type=template&id=f5de7a5e"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andresrivas/NoSincronizar/Vue/Swift Fulfillment/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__